import { get, post, put, destroy } from "./base";

const PreferenceServ = {
    getLanguages: (params) => get("/preferences/languages", { params }),
    getCurrencies: (params) => get("/preferences/currencies", { params }),

    addLanguage: (payload) => post("/preferences/languages", payload),
    updateLanguage: (id, payload) => put(`/preferences/languages/${id}`, payload),
    deleteLanguage: (id) => destroy(`/preferences/languages/${id}`),

    addCurrency: (payload) => post("/preferences/currencies", payload),
    updateCurrency: (id, payload) => put(`/preferences/currencies/${id}`, payload),
    deleteCurrency: (id) => destroy(`/preferences/currencies/${id}`),
};

export default PreferenceServ;
